<div class="SLV2-error-popup-area">
    <h5 class="SLV2-error-popup-hdng">What didn’t you like?</h5>
    <ul class="SLV2-error-popup-cklist">
        <li>
            <label>
                <input type="checkbox" /><span>Incorrect concept</span>
            </label>
        </li>
        <li>
            <label>
                <input type="checkbox" /><span>Unclear audio</span>
            </label>
        </li>
        <li>
            <label>
                <input type="checkbox" /><span>Unable to play</span>
            </label>
        </li>
    </ul>

    <label class="SLV2-error-fld-title">Add error details (if any)</label>
    <input type="text" class="SLV2-error-fld" placeholder="type here" />


    <div class="SLV2-popup-actn-area">
        <button class="SLV2-popup-text-btn mr-5" (click)="close()">Cancel</button>
        <button class="SLV2-popup-solid-btn">Submit</button>
    </div>

</div>
